import { createApp } from 'vue'
import App from './App.vue'
import BootstrapVue3 from 'bootstrap-vue-3'
import router from './router'
import store from './store'
import axios from "axios";
import VueAxios from 'vue-axios'
import Notifications from '@kyvg/vue3-notification'
import "./assets/scss/style.scss";
import {$t, setLang} from "@/i18n";

setLang('en')
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common = {
    'Content-Type': 'application/json;charset=UTF-8',
}

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.isLoggedIn) {
        next('/login');
    } else {
        next();
    }
});

const app = createApp(App)

app.config.globalProperties.$t = (key: string, params: any = {}, fallback: string|null = null) => {
    return $t(key, params, fallback)
}
app
    .use(VueAxios, axios)
    .use(Notifications)
    .use(BootstrapVue3)
    .use(store)
    .use(router)
    .mount('#app')
